import * as React from 'react'

import translations from '../locales.json'
import { BrowserRouter } from 'react-router'
import useTranslation, {
  TranslationProvider,
} from '../../shared/TranslationProvider'
import { CoachHeader, CoachHeaderLight } from '../CoachHeader'
import DataTable from './DataTable'
import Filters from './Filters'
import DownloadFeedbacksModal from './DownloadFeedbacksModal'

function CoachFeedback({ feedback, select = false }) {
  const { t } = useTranslation('Feedback')

  const [columnFilters, setColumnFilters] = React.useState([
    {
      id: 'type',
      value: null,
    },
  ])

  const dataTableProps = {
    feedback: feedback.serviceRequests,
    columnFilters,
    setColumnFilters,
    select: select,
  }
  return (
    <div className="mx-2 my-2 flex flex-col gap-10 font-roboto md:my-6 lg:mx-6">
      <div className="flex flex-col gap-6">
        <CoachHeader>
          <CoachHeaderLight>{t('light_header')}</CoachHeaderLight>{' '}
          {t('dark_header')}
        </CoachHeader>
        <div>{t('description')}</div>
        <div className="flex justify-between">
          <Filters {...dataTableProps} />
          <DownloadFeedbacksModal />
        </div>
        <DataTable {...dataTableProps} />
      </div>
    </div>
  )
}

export default function CoachFeedbackWithProviders({ locale, ...props }) {
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.coach_services.CoachFeedback"
    >
      <BrowserRouter>
        <CoachFeedback {...props} />
      </BrowserRouter>
    </TranslationProvider>
  )
}
